import { PlatformLanguageCode } from '@tov-plus/domain';

import { msg } from './i18n';

function normalizeLanguageCode(code: string) {
  const normalized = code.trim().toLowerCase().replace('_', '-');

  if (normalized === 'en-us') {
    return PlatformLanguageCode.English;
  }

  if (normalized === 'he-il') {
    return PlatformLanguageCode.Hebrew;
  }

  return normalized;
}

export function getLanguageLabel(code: string) {
  switch (normalizeLanguageCode(code)) {
    case PlatformLanguageCode.English:
      return msg('general.languages.en');
    case PlatformLanguageCode.Hebrew:
      return msg('general.languages.he');
    default:
      return code;
  }
}
